import { render, staticRenderFns } from "./Flats.vue?vue&type=template&id=78a531e0&scoped=true"
import script from "./Flats.vue?vue&type=script&lang=js"
export * from "./Flats.vue?vue&type=script&lang=js"
import style0 from "./Flats.vue?vue&type=style&index=0&id=78a531e0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a531e0",
  null
  
)

export default component.exports